<template>
    <el-row :gutter="20"  style="padding: 30px;min-height: 800px;">
        <h1 class="title">网站公告</h1>
        <div class="el-line-h"></div>
        
        
        <div class="ggContent" v-for="(notice,i) in notices" :key="notice.NoticeID"
        @click="onBtnNotic(notice.NoticeID)"><i :class="`el-icon-lx-text`"></i>{{ notice.Title }} <span class="time">{{ notice.InsertTime }}</span></div>
       

    </el-row>

</template>

<script>
import netutil from "../../common/netutil.js";

export default {
    name: "guide1",
    data() {
        return {
            notices:[],

        };
    },
    components: {

    },
    computed: {

    },
    created() {
this.getNotice();
    },
    activated() {

    },
    deactivated() {

    },
    methods: {
        getNotice() {
            var self = this;
            var param = {};
            netutil.get("public/getnoticelist", param,
                function (data) {
                    self.notices = data.data0;
                },
                function (msg) {

                });
        },
        onBtnNotic(id)
        {
            this.$router.push('/about?index=2&id=' + id);
        },

    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.title {
    font-size: 32px;
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: 400;
    color: #ff8800;
}

.ggContent {
    cursor: pointer;
    line-height: 20px;
    height: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-decoration: underline;
    text-underline-offset: 3px;
    color: #5d5d5d;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.time
{
    float: right;
}
</style>
